const _require = require('@truqc/content-path'),
  appendPath = _require.appendPath,
  getContentValue = _require.getContentValue,
  getFlattenedContentValues = _require.getFlattenedContentValues;
const _require2 = require('../lib/evaluateSource'),
  combForSource = _require2.combForSource,
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate ifContentBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const comb = await combForSource(source, content, parentContentPath, transientContext, nativeFunctions);
  const atPath = await evaluateSource(source.atPath, content, parentContentPath, transientContext, nativeFunctions);
  if (atPath !== undefined) {
    const value = getContentValue(appendPath(parentContentPath, atPath), content);
    return comb(value);
  }
  const getEvaluatedContentValues = async (paths, requireAllValues) => {
    const evaluatedPaths = (await evaluateSource(paths, content, parentContentPath, transientContext, nativeFunctions)) || [];
    const fullPaths = evaluatedPaths.map(sourcePath => appendPath(parentContentPath, sourcePath));
    return getFlattenedContentValues(fullPaths, content, requireAllValues);
  };
  const atAnyPaths = await evaluateSource(source.atAnyPaths, content, parentContentPath, transientContext, nativeFunctions);
  if (atAnyPaths !== undefined) {
    const paths = Array.isArray(atAnyPaths) ? atAnyPaths : [atAnyPaths];
    const values = (await getEvaluatedContentValues(paths, false)) || [];
    return values.length > 0 && values.some(comb);
  }
  const atAllPaths = await evaluateSource(source.atAllPaths, content, parentContentPath, transientContext, nativeFunctions);
  if (atAllPaths !== undefined) {
    const paths = Array.isArray(atAllPaths) ? atAllPaths : [atAllPaths];
    const values = (await getEvaluatedContentValues(paths, true)) || [];
    const doesNotEqual = await evaluateSource(source.doesNotEqual, content, parentContentPath, transientContext, nativeFunctions);
    if (doesNotEqual !== undefined && values.length === 0) {
      // see test case 'should return true when nonexistent content atAllPaths doesNotEqual'
      return true;
    }
    return values.length > 0 && values.every(comb);
  }
  return undefined;
};
module.exports = {
  evaluate
};